import { render, staticRenderFns } from "./productStock.vue?vue&type=template&id=fbd6432c&scoped=true&"
import script from "./productStock.vue?vue&type=script&lang=js&"
export * from "./productStock.vue?vue&type=script&lang=js&"
import style0 from "./productStock.vue?vue&type=style&index=0&id=fbd6432c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd6432c",
  null
  
)

export default component.exports